import {Component, forwardRef, input, OnInit, output} from '@angular/core';
import {MatRadioChange, MatRadioModule} from "@angular/material/radio";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {RadioButtonInfo} from '../models';
import {TranslocoDirective} from '@jsverse/transloco';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-radio-buttons-question',
    templateUrl: './radio-buttons-question.component.html',
    styleUrl: './radio-buttons-question.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RadioButtonsQuestionComponent),
            multi: true
        }
    ],
    imports: [MatRadioModule, TranslocoDirective, CommonModule],
    standalone: true
})
export class RadioButtonsQuestionComponent<T> implements OnInit, ControlValueAccessor {
  isFlexDirectionColumn = input<boolean>(false);
  value = input<T>();
  buttonsInfo = input<RadioButtonInfo<T>[]>([]);
  disabled = input<boolean>(false);

  selectedOptionChange = output<T>();

  selectedOption?: T;

  onChange: any = () => {
  };

  onTouch: any = () => {
  };

  ngOnInit(): void {
    this.selectedOption = this.value() ?? this.buttonsInfo()[0].value;
    this.selectedOptionChange.emit(this.selectedOption);
  }

  updateSelectedOption(selectedOption: MatRadioChange) {
    this.selectedOption = selectedOption.value;
    this.selectedOptionChange.emit(this.selectedOption!)
    this.onChange(this.selectedOption);
  }

  writeValue(obj: T): void {
    this.selectedOption = obj;
    this.selectedOptionChange.emit(this.selectedOption);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  isChecked(value: T, selectedOption: T) {
    return value === selectedOption;
  }
}
